module.exports = __webpack_public_path__ + "img/AGR-B-2-III.50841d5d.png";